import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpDeleteBulkExperienceShellPhotoOptions,
	httpDeleteBulkExperienceShellPhoto
} from '@/features/experience-shell/http/experience-shell.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useDeleteExperienceShellPhotos = (
	urlParams: HttpDeleteBulkExperienceShellPhotoOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpDeleteBulkExperienceShellPhotoOptions['params']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (params) =>
			httpDeleteBulkExperienceShellPhoto({ urlParams, params }),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
